import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
// eslint-disable-next-line import/no-cycle
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard' } },
    ...apps,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  if (to.meta.authOrNoAuth) {
    return next()
  }
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })
      const userData = getUserData()
      if (!userData.email_verified_at && to.name !== 'not-verified') {
        return next({ name: 'not-verified' })
      }
      if (!userData.other_email) {
        return next({ name: 'setup-welcome' })
      }

    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()

    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  if (isLoggedIn && to.name !== 'settings') {
    const userData = getUserData()

    if ((userData.country == null || userData.currency == null) && to.meta.page_group !== 'setup') {
      if (!userData.email_verified_at && to.name !== 'not-verified') {
        return next({ name: 'not-verified' })
      }
      return next({ name: 'setup-welcome' })
    }

    if ((userData.country !== null && userData.currency !== null) && to.meta.page_group === 'setup') {
      return next({ name: 'dashboard' })
    }
    if (userData.email_verified_at && !userData.other_email && to.meta.page_group !== 'setup') {
      return next({ name: 'settings' })
    }
  }
  const userData = getUserData()
  if (isLoggedIn && !userData.email_verified_at && to.name !== 'not-verified' && !userData.other_email) {
    return next({ name: 'not-verified' })
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
